var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H6Z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.52 15.137-.533-1.862a2.001 2.001 0 1 0 .962-.274l.532 1.862-.962.274Zm-3.75-.637h-.812a3 3 0 0 0-1.056-1.82l.388-.68h3.623l-2.143 2.5Zm-2.356-.914-.02-.02-.532.934h1.075a2 2 0 0 0-.523-.914Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.566 14.752.96-1.681a1.998 1.998 0 0 0-1.94.515 2 2 0 1 0 3.35 1.914H8a.5.5 0 0 1-.434-.748Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4Zm9 4h1.5a.5.5 0 0 1 .485.379l.498 1.992.185.647a3.003 3.003 0 0 1 2.453.86 3 3 0 1 1-5.09 1.687l-.651.76a.5.5 0 0 1-.38.175h-1.042a3 3 0 1 1-1.925-3.316l.526-.92.132-.264H9v-1h2.309l-.5 1h3.55l-.25-1H13V9Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionActivity);
export default __webpack_public_path__ + "static/media/ic_action_activity.4c85a933c585ffd0e242a2d4c4e308c1.svg";
export { ForwardRef as ReactComponent };